import React, { useEffect, useState } from "react";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import { t } from "i18next";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import { Box } from "@mui/material";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import CoreIconDelete from "../../../app/core/components/CoreIconDelete/CoreIconDelete";
import {
  useAddServiceGroupMutation,
  useCreateServiceGroupMutation,
  useDeleteServiceGroupMutation,
  useEditServiceGroupMutation,
  useGetUploadURLQuery,
} from "../../api/admin/ServiziApi";
import { useDispatch, useSelector } from "react-redux";
import { doUploadImgService } from "./serviziSlide";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";

const ServiceTwoLevel = ({ data, onClose }) => {
  const studioId = useSelector((state) => state.app.studioId);
  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    IconUrl: "",
    fileImg: null,
    previewImage: null,
  });
  const [edit, setEdit] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    Name: "",
    Description: "",
  });
  const [confirmDeleteGroupDialog, setConfirmDeleteGroupDialog] =
    useState(false);

  const dispatch = useDispatch();

  const { data: urlData, refetch } = useGetUploadURLQuery();

  const [addService] = useAddServiceGroupMutation();
  const [createGroupService, { isLoading: loadingCreate }] =
    useCreateServiceGroupMutation();
  const [editGroupService, { isLoading: loadingEdit }] =
    useEditServiceGroupMutation();
  const [deleteGroupService, { isLoading: loadingDelete }] =
    useDeleteServiceGroupMutation();

  const iconURLValid =
    formData.IconUrl !== "/img/placeholder-image.svg" ? formData.IconUrl : "/";

  useEffect(() => {
    if (data) {
      setFormData({
        Id: data?.id,
        Name: data?.name,
        Description: data?.description,
        IconUrl: data?.iconUrl || data?.iconURL,
      });
      if (data.practiceServices) {
        setEdit(true);
      }
    }
  }, [data]);

  const handleAddService = async (res) => {
    const body = {
      idCategory: res?.Data?.id,
      idPracticeService: data.id,
    };
    if (studioId) body.studioId = studioId;

    await addService({ group: body })
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(t("ServiceGroupNotCreated"));
          return;
        }
        toast.success(t("ServiceGroupCreated"));
        onClose();
      })
      .catch(() => {
        toast.error(t("ServiceGroupNotCreated"));
      });
  };

  const handleSave = async () => {
    const errors = {};
    if (!formData.Name) errors.Name = t("FieldRequired");
    if (!formData.Description) errors.Description = t("FieldRequired");
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    try {
      const imgUrl = formData.fileImg ? await uploadIMG() : ""; //se l'utente ha droppato un file allora chiami upload logo altimenti passi stringa vuota

      if (edit) {
        const editedGroupService = {
          id: formData.Id,
          name: formData.Name,
          description: formData.Description,
          iconUrl: imgUrl || iconURLValid,
        };
        await editGroupService(editedGroupService)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("ServiceGroupNotEdited"));
              return;
            } else {
              refetch();
              toast.success(t("ServiceGroupUpdated"));
              onClose();
            }
          });
      } else {
        const newGroupService = {
          name: formData.Name,
          description: formData.Description,
          iconURL: imgUrl || formData.IconUrl,
        };
        if (!data.isForAll && data.activeStudios.length > 0) {
          newGroupService.studioId = data.activeStudios[0].id;
        }
        await createGroupService(newGroupService)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("ServiceGroupNotCreated"));
              return;
            }
            handleAddService(res);
          })
          .catch(() => {
            toast.error(t("ServiceGroupNotCreated"));
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }

    refetch(); //refetch per riottenere un nuovo link per l'immagine
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setValidationErrors({ ...validationErrors, [name]: "" });
  };

  const handleFileDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prev) => ({ ...prev, previewImage: reader.result }));
    };
    setFormData((prev) => ({ ...prev, fileImg: file }));
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = async () => {
    setFormData((prev) => ({
      ...prev,
      previewImage: null,
      fileImg: null,
      IconUrl: "",
    }));
  };

  const uploadIMG = async () => {
    const linkURL = urlData.Data;
    let clearURL = "";
    if (linkURL) {
      const uploadFileUrl = linkURL;
      await dispatch(
        doUploadImgService({
          url: uploadFileUrl,
          file: new Blob([formData.fileImg]),
          type: formData.fileImg.type,
        })
      ).then((res) => {
        if (res.payload && res.payload.Exception) {
          toast.error(res.payload.Exception);
        }
      });
      clearURL = uploadFileUrl.split("?")[0];
      setFormData({
        ...formData,
        IconUrl: clearURL,
      });
    }
    return clearURL;
  };

  const handleDeleteGroup = (el) => {
    setConfirmDeleteGroupDialog(true);
  };

  const handleCloseDeleteDialod = () => setConfirmDeleteGroupDialog(false);

  const handleConfermDeleteDialog = async () => {
    deleteGroupService(data.id).then((res) => {
      if (res.data && res.data.Result !== 1) {
        toast.error(res.data.Exception || t("ServiceGroupNotDelete"));
        return;
      }
      toast.success(t("ServiceGroupDelete"));
      handleCloseDeleteDialod();
      onClose();
    });
  };

  return (
    <div>
      <h2 className="text-center">
        {edit ? t("EditTwoLevelService") : t("CreateTwoLevelService")}{" "}
      </h2>

      <div className="flex space-x-10 p-4 justify-center">
        <div className="w-1/2">
          <CoreInputField
            label={t("Name")}
            name="Name"
            value={formData.Name}
            onChange={handleInputChange}
            fullWidth
            required
            error={Boolean(validationErrors.Name)}
            helperText={validationErrors.Name}
          />

          <div className="pt-8">
            <CoreTextArea
              label={t("Description")}
              name="Description"
              value={formData.Description}
              onChange={handleInputChange}
              fullWidth
              rows={4}
              required
              error={Boolean(validationErrors.Description)}
              helperText={validationErrors.Description}
            />
          </div>
          <div>
            <h3>{t("InsertServiceImg")}</h3>
            <div>
              {formData.previewImage || iconURLValid ? (
                <div className="flex flex-col justify-center items-center">
                  <div className="relative p-4">
                    <img
                      src={formData.previewImage || iconURLValid}
                      alt="Preview"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "150px",
                        objectFit: "cover",
                      }}
                    />
                    <CoreIconDelete onDelete={handleDeleteImage} />
                    <div>
                      {formData.fileImg && (
                        <CoreIconDelete onDelete={handleDeleteImage} />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <Dropzone onDrop={handleFileDrop} accept={["image/*", ".pdf"]}>
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className="flex w-full justify-center items-center p-4 text-center"
                      {...getRootProps()}
                      style={{
                        border: "2px dashed #ccc",
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />
                      <Box display="flex" flexDirection="column">
                        <p className="text-center text-gray">{t("DropFile")}</p>
                        <CoreButtonIcon
                          icon={
                            <UploadFileRoundedIcon
                              className="text-gray"
                              sx={{ fontSize: 70 }}
                            />
                          }
                        />
                        <CoreButtonIcon
                          icon={<SearchRoundedIcon className="text-gray" />}
                          testo={t("Search")}
                          className="text-gray"
                        />
                      </Box>
                    </div>
                  )}
                </Dropzone>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="flex w-full justify-around mt-10">
        {data && (
          <CoreButton
            className="bg-red-700 btn-round border-red-700"
            variant="contained"
            testo={loadingDelete ? t("Wait") : t("Delete")}
            onClick={handleDeleteGroup}
            disabled={loadingDelete || loadingEdit}
          />
        )}
        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={t("Save")}
          onClick={handleSave}
          disabled={loadingCreate || loadingEdit}
        />
      </div>
      <CoreDialog
        open={confirmDeleteGroupDialog}
        title={t("Delete") + " " + t("serviceGroup")}
        content={`${t("ServiceDeleteGroupConfirm")} ${data?.name}?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfermDeleteDialog}
        closeDialog={handleCloseDeleteDialod}
      />
    </div>
  );
};

export default ServiceTwoLevel;
